import { useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import { ChatBubbleIcon } from '@/components/game/GameIcons'
import { FeedbackModal } from './FeedbackModal'

const LABEL = 'Un bug ? Une idée ? Une question ?'

/**
 * Persistent floating trigger (message-in-a-bottle) for in-app feedback. Lives
 * in AppLayout so it's reachable from every page — including public ones — and
 * works logged-out. Auto-attaches the current page + pseudo as context; the
 * server adds the browser.
 */
export function FeedbackButton() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  const { user } = useAuth()
  const triggerRef = useRef<HTMLButtonElement>(null)

  // Full SPA route as context (origin + in-app path).
  const page = `${window.location.origin}${pathname}`

  // Restore focus to the FAB when the dialog closes (aria-modal contract).
  const close = () => {
    setOpen(false)
    triggerRef.current?.focus()
  }

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        onClick={() => setOpen(true)}
        aria-label={LABEL}
        title={LABEL}
        // Positioning (fixed + safe-area insets + mobile lift) lives in the
        // `.feedback-fab` class in index.css — it needs a media query + env(),
        // which inline styles can't express and Tailwind's JIT can drop.
        className="feedback-fab grid place-items-center w-12 h-12 rounded-full bg-sand-500 text-ocean-900 shadow-lg shadow-ocean-900/40 hover:bg-sand-300 focus:outline-none focus:ring-2 focus:ring-sand-300 transition-colors"
      >
        <ChatBubbleIcon className="w-7 h-7" />
      </button>

      {open && (
        <FeedbackModal
          open
          onClose={close}
          page={page}
          pseudo={user?.pseudo ?? null}
        />
      )}
    </>
  )
}
